import React, { useEffect, useContext, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { LIST_MODELS_ADMIN } from "../../../../graphql/graph.js";
import ModelTables from "./ModelTables.jsx";
import AddUpdateModelModal from "../../../Modals/AddUpdateModel";
import AddModelVersion from "../../../Modals/AddModelVersion";
import { AuthContext } from "../../../../context/authContext";
import Styles from "./styles";
import PrimaryBtn from "components/Shared/Buttons/PrimaryBtn/PrimaryBtn";

const ModelManager = () => {
  const { isSuperAdmin } = useContext(AuthContext);
  const [modelData, setModelData] = useState([]);
  const [modelToUpdate, setModelToUpdate] = useState(null);
  const [viewAll, setViewAll] = useState(false);
  const [showAddUpdateModelModal, setShowAddUpdateModelModal] = useState(false);
  const [showAddModelVersionModal, setShowAddModelVersionModal] = useState(false);

  const [getModels, { data: modelResults }] = useLazyQuery(LIST_MODELS_ADMIN, {
    context: { clientName: "graph" },
  });

  useEffect(() => {
    getModels({ variables: { listAll: 1 } });
  }, []);

  useEffect(() => {
    if (modelResults) {
      setModelData(modelResults.listModelAdmin.data);
    }
  }, [modelResults]);

  const handleClickAddModelVersion = (row) => {
    setModelToUpdate({
      ...row.model,
    });
    setShowAddModelVersionModal(true);
  };

  const handleClickUpdateModel = (row) => {
    setModelToUpdate({
      ...row.model,
      modelVersion: row.modelVersion,
    });
    setShowAddUpdateModelModal(true);
  };

  const handleClickAddModel = () => {
    setShowAddUpdateModelModal(true);
  };

  const onCloseModal = () => {
    setShowAddUpdateModelModal(false);
    setShowAddModelVersionModal(false);
    setModelToUpdate(null);
  };

  if (!isSuperAdmin) {
    return null;
  }

  const filteredModelData = viewAll
    ? modelData
    : modelData.filter((model) => model.modelStatus === 1);

  return (
    <Styles.ManageModelsContainer>
      <Styles.Header>
        <Styles.HeaderText>Model Manager</Styles.HeaderText>
        <PrimaryBtn
          label={"Add Model"}
          handleClick={handleClickAddModel}
          icon="plus"
          padding="10px 20px"
        />
      </Styles.Header>

      <ModelTables
        dataRows={filteredModelData}
        addVersion={handleClickAddModelVersion}
        updateModel={handleClickUpdateModel}
      />

      {showAddUpdateModelModal && (
        <AddUpdateModelModal
          showModal={showAddUpdateModelModal}
          setShowModal={onCloseModal}
          modelToUpdate={modelToUpdate}
          setModelToUpdate={setModelToUpdate}
        />
      )}
      {showAddModelVersionModal && (
        <AddModelVersion
          showModal={showAddModelVersionModal}
          setShowModal={onCloseModal}
          modelToUpdate={modelToUpdate}
          setModelToUpdate={setModelToUpdate}
        />
      )}
    </Styles.ManageModelsContainer>
  );
};

export default ModelManager;
